import React from 'react';
import DrawerBody from 'components/ui/DrawerBody';
import DrawerHeader from 'components/ui/DrawerHeader';
import DrawerFooter from 'components/ui/DrawerFooter';
import CreateProspectDrawerDetailsStep from './CreateProspectDrawerDetailsStep';
import CtaPrimary from 'components/ui/CtaPrimary';

import errorAnimationData from 'assets/error.json';
import loadingAnimationData from 'assets/loading.json';
import successAnimationData from 'assets/success.json';

import { getTranslatedString } from 'helpers/i18n';
import DrawerSuccessMessages from 'components/ui/DrawerSuccessMessages';
import Lottie from 'react-lottie';

const FORM_NAME = 'prospects_form';

class CreateProspectDrawerWizard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      loading: false,
      success: false,
      formData: {},
    };
  }

  handleLoadingChange = options => {
    this.setState({
      loading: options.isLoading,
      error: options.isError,
      formData: options.values,
    });
  };

  handleSubmissionComplete = formData => {
    this.setState({
      error: false,
      loading: false,
      success: true,
      formData: formData,
    });
  };

  render() {
    if (this.state.success) {
      return this.renderSuccess(this.state.formData);
    } else if (this.state.loading) {
      return this.renderLoading(this.state.formData);
    } else if (this.state.error) {
      return this.renderError(this.state.formData);
    } else {
      return this.renderFormWizard();
    }
  }

  renderFormWizard = () => {
    const { loading, formData } = this.state;

    return (
      <React.Fragment>
        <DrawerHeader
          onClose={this.props.handleClose}
          title={getTranslatedString('prospects.create')}
        />
        <DrawerBody>{this.renderDetailsStep(formData)}</DrawerBody>
        <DrawerFooter
          primaryActionFormName={FORM_NAME}
          primaryActionText={getTranslatedString('create')}
          primaryActionDisabled={loading}
        />
      </React.Fragment>
    );
  };

  renderSuccess = formData => {
    const defaultOptions = {
      loop: false,
      autoplay: true,
      animationData: successAnimationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    return (
      <DrawerSuccessMessages
        headerImageSource={<Lottie options={defaultOptions} height={150} width={150} />}
        headerText={getTranslatedString('addProspectDrawer.successHeader', {
          first_name: formData.first_name,
          last_name: formData.last_name,
        })}
        bodyText={getTranslatedString('globalDrawer.successBody')}
        cta={
          <CtaPrimary onClick={() => this.setState({ success: false }, this.props.handleClose)}>
            {getTranslatedString('close')}
          </CtaPrimary>
        }
      />
    );
  };

  renderError = formData => {
    const defaultOptions = {
      loop: false,
      autoplay: true,
      animationData: errorAnimationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    return (
      <DrawerSuccessMessages
        headerImageSource={<Lottie options={defaultOptions} height={150} width={150} />}
        headerText={getTranslatedString('globalDrawer.errorHeader', {
          name: `${formData.first_name} ${formData.first_name}`,
        })}
        bodyText={getTranslatedString('globalDrawer.errorBody')}
        cta={
          <CtaPrimary onClick={() => this.setState({ error: false })}>
            {getTranslatedString('globalDrawer.goBack')}
          </CtaPrimary>
        }
      />
    );
  };

  renderLoading = formData => {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: loadingAnimationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };

    return (
      <DrawerSuccessMessages
        headerImageSource={<Lottie options={defaultOptions} height={150} width={150} />}
        headerText={getTranslatedString('globalDrawer.loadingHeader', {
          object: `${formData.first_name} ${formData.last_name}`,
        })}
        bodyText={getTranslatedString('globalDrawer.loadingBody')}
      />
    );
  };

  renderDetailsStep = formData => {
    return (
      <CreateProspectDrawerDetailsStep
        trafficSources={this.props.trafficSources}
        formName={FORM_NAME}
        formData={{}}
        onLoadingChange={this.handleLoadingChange}
        onSubmissionComplete={this.handleSubmissionComplete}
        properties={this.props.properties}
        unitTypes={this.props.unitTypes}
      />
    );
  };
}

export default CreateProspectDrawerWizard;
